/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILxsWhatsNewViewProps } from './lxs-whats-new';
import { useModal } from '../../components/modal';

export default (props: ILxsWhatsNewViewProps) => {
    const className = 'lxs-whats-new';
    const { setOpen } = useModal();
    const modalRef = React.useRef<HTMLDivElement>(null);
    const cookieBox = document.getElementById('cmpbox');

    const handleClickOutside = (event: MouseEvent) => {
        if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
            props.context.request.cookies.set<Date>(props.resources.lxsWhatsNewCookieName, props.currentDate);
            props.context.request.cookies.set<string>(props.resources.lxsWhatsNewCookieHashName, props.contentHash);
        }
    };

    React.useEffect(() => {
        const checkVisibility = () => {
            if (cookieBox?.style.display !== 'block') {
                document.addEventListener('mousedown', handleClickOutside);
                setOpen({
                    content: (
                        <div className={`${className}__modal`}>
                            <h1 className={`${className}__modal-title`}>{props.resources.title}</h1>
                            {props.text}
                        </div>
                    ),
                    size: props.modalSize
                });
            }
        };

        // We need to check for cookie consent banner. Afterwards the popup can be displayed.
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    checkVisibility();
                }
            });
        });

        if (cookieBox && cookieBox.style.display === 'block') {
            observer.observe(cookieBox, { attributes: true });
        } else {
            checkVisibility();
        }

        return () => {
            if (observer) {
                observer.disconnect();
            }
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [cookieBox]);

    return <div className={`${className}`} ref={modalRef}></div>;
};
